import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '@/shared/components/ui/empty'

export const NotFoundPage = () => {
	const { t } = useTranslation()

	return (
		<Empty className='h-screen w-screen'>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<AlertTriangleIcon />
				</EmptyMedia>
				<EmptyTitle>
					{t('requested_page_not_found', {
						defaultValue: 'Requested page not found.',
					})}
				</EmptyTitle>
				<EmptyDescription>
					{t('requested_page_not_found_description', {
						defaultValue:
							"You definitely typed the correct URL, it's the keyboard's fault. Refresh the page or go back to the main screen",
					})}
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
